import classNames from 'classnames';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import React from 'react';

import * as styles from './Carousel.module.scss';

type DotButtonProps = {
  selected: boolean;
  onClick: () => void;
};

export const DotButton: React.FC<DotButtonProps> = ({
  selected,
  onClick,
  ...rest
}): JSX.Element => (
  <button
    className={classNames({
      [styles.dot]: true,
      [styles.isSelected]: selected,
    })}
    onClick={onClick}
    {...rest}
  />
);

type PrevNextButtonProps = {
  enabled: boolean;
  onClick: () => void;
};

export const PrevButton: React.FC<PrevNextButtonProps> = ({
  enabled,
  onClick,
}): JSX.Element => (
  <button
    className={classNames(styles.button, styles.buttonPrev)}
    onClick={onClick}
    disabled={!enabled}
    aria-label="Previous"
  >
    <ArrowLeft size={20} className="text-white" />
  </button>
);

export const NextButton: React.FC<PrevNextButtonProps> = ({
  enabled,
  onClick,
}): JSX.Element => (
  <button
    className={classNames(styles.button, styles.buttonNext)}
    onClick={onClick}
    disabled={!enabled}
    aria-label="Next"
  >
    <ArrowRight size={20} className="text-white" />
  </button>
);
